(function () {
  var timers = document.querySelectorAll('.product__countdown[data-end]');
  if (!timers.length) return;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick(timer) {
    var end = new Date(timer.dataset.end).getTime();
    if (isNaN(end)) { timer.style.display = 'none'; return null; }
    var now = Date.now();
    var diff = end - now;

    if (diff <= 0) {
      var expired = timer.dataset.expiredText || '';
      if (expired) {
        timer.classList.add('is-expired');
        timer.querySelector('.product__countdown-timer').textContent = expired;
        timer.querySelector('.product__countdown-prefix').textContent = '';
      } else {
        timer.style.display = 'none';
      }
      return 'stop';
    }

    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    var dEl = timer.querySelector('[data-d]');
    var hEl = timer.querySelector('[data-h]');
    var mEl = timer.querySelector('[data-m]');
    var sEl = timer.querySelector('[data-s]');
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }

  timers.forEach(function (t) {
    tick(t);
    var iv = setInterval(function () {
      if (tick(t) === 'stop') clearInterval(iv);
    }, 1000);
  });
})();
